import React from 'react';
import { Cart, Price } from '@components';
import { Cart as CartInterface } from '@services/cart';
import { OrderExpanded } from '@services/checkout';
import { Accordion, AccordionContent, AccordionHeader, AccordionItem, Icon, Typography } from 'gd-design-library';
import classnames from 'classnames/bind';

import styles from './CollapsibleCart.module.scss';
import { DiscountCodeReference } from '@commercetools/platform-sdk';

const CN = 'collapsible-cart-table';
const summaryClassName = `${CN}__summary`;
const summaryWrapperClassName = `${CN}__summary-wrapper`;
const detailsClassName = `${CN}__details`;

const cx = classnames.bind(styles);

interface Props {
  cart: CartInterface | OrderExpanded | null,
  onItemQuantityChange: (lineItemId: string, newQuantity: number) => unknown,
  onLineItemRemove: (lineItemId: string) => unknown,
  className?: string;
  onAddDiscountCode: (discountCode: string) => Promise<void>,
  onRemoveDiscountCode: (discountCode: DiscountCodeReference) => Promise<void>,
  isLoadingDiscount: boolean;
  orderId?: string;
}

export const CollapsibleCart: React.FC<Props> = ({
  cart,
  onItemQuantityChange,
  onLineItemRemove,
  onAddDiscountCode,
  onRemoveDiscountCode,
  className,
  isLoadingDiscount,
  orderId
}) => (
  <Accordion>
    <AccordionItem className={ `${cx(CN)} ${className}` } id='collapsible-cart-accordion'>
      <AccordionHeader
        className={ cx(summaryWrapperClassName) }
        expandIcon={ <Icon name='arrowDown' width={ 20 } height={ 20 } /> }
      >
        <Typography variant='p' as='div' className={ cx(summaryClassName) }>
          Show order summary
          { cart && <Price price={ cart.totalPrice } /> }
        </Typography>
      </AccordionHeader>
      <AccordionContent>
        <div className={ cx(detailsClassName) }>
          <Cart
            cart={ cart }
            onAddDiscountCode={ onAddDiscountCode }
            onRemoveDiscountCode={ onRemoveDiscountCode }
            onItemQuantityChange= { onItemQuantityChange }
            onLineItemRemove={ onLineItemRemove }
            isLoadingDiscount={ isLoadingDiscount }
            readOnly
            title={ orderId ? 'Order Details' : undefined }
            orderNumber={ orderId }
            hidePromoCode={ !!orderId }
          />
        </div>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
);
